import type {Locale} from 'date-fns';

import {DayOfWeek} from './DayOfWeek';
import {LocaleDateTimeFormat} from './LocaleDateTimeFormat';

export type LocaleConfig = {
  timezone: string;
  language: string;
  dateFnsLocale?: Locale;
  dateTimeFormat: {
    [D in LocaleDateTimeFormat]: string;
  };
  calendar: {
    firstDayOfTheWeek: DayOfWeek;
  };
  number: {
    thousandsSeparator: string;
    decimalSeparator: string;
  };
  currency: {
    thousandsSeparator: string;
    decimalSeparator: string;
    position: 'before' | 'after';
  };
};
